import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    Data: '',
    Date: '',
    MyBalance: [],
}

export const myShiftsReducer = createSlice({
    name: 'myShiftsReducer',
    initialState,
    reducers: {
        setMyShifts: (state, action) => {
            state.Data = action.payload
        },
        setMyShiftsDate: (state, action) => {
            state.Date = action.payload
        },
        setMyBalance: (state, action) => {
            state.MyBalance = action.payload
        },

    },
})

export const { setMyShifts, setMyShiftsDate, setMyBalance } = myShiftsReducer.actions

export default myShiftsReducer.reducer
